module.exports = __webpack_public_path__ + "static/media/thanos.ba24127f.mp3";